function initAnnouncementBanner() {
  var announcementCarousel = document.querySelector('[data-announcement-banner].splide');
  var announcementCarouselInner = document.querySelector('[data-announcement-carousel-container].splide__list');
  var autoPlaySpeed = announcementCarouselInner.getAttribute('data-autoplay-speed') * 1000;
    
  var announcementCarouselSplide = new Splide(announcementCarousel, {
    type: 'loop',
    speed: 1000,
    interval: autoPlaySpeed,
    autoplay: true,
    pauseOnHover: true,
    pagination: false,
    arrows: false,
    perPage: 1,
    perMove: 1
  });
  announcementCarouselSplide.mount();
}

$(document).ready(function() {
  initAnnouncementBanner();
});